<template>
<v-menu open-on-hover top offset-y>
  <template v-slot:activator="{ on }">
  <v-btn small icon v-on="on" @click="toggle">
      <v-icon small color="green" v-if="value===1">far fa-check-square</v-icon>
       <v-icon small color="red" v-if="value===0">far fa-square</v-icon>
    </v-btn>
      </template>
  <v-card>
    <v-card-text>
      <p class="mb-0">
        {{tip}}
      </p>
    </v-card-text>
  </v-card>
</v-menu>
</template>
<script>
export default {
  props: ['value', 'tip', 'disabled'],
  name: "",
  data: () => ({

  }),
  methods: {
    toggle() {
      if (this.disabled) {
        return
      }
      if (this.value === 0) {
        this.$emit('input', 1)
      } else {
        this.$emit('input', 0)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
